export class ReleaseSummarySearchCriteria {

  entityName!: string;
  entityId!: string;
  entityRevision!: number;
  orgUnitId!: string;
  excludeCancelled!: boolean;
  pageNumber!: number;
  sortColumn: string = "ENTITY_ID";
  sortDirection: string = "ASCENDING";
}
